// redux/reducers/companyReducer.js

import {
    GET_COMPANY_REQUEST, GET_COMPANY_SUCCESS, GET_COMPANY_FAIL,
    GET_COMPANY_BY_CODE_REQUEST, GET_COMPANY_BY_CODE_SUCCESS, GET_COMPANY_BY_CODE_FAIL,
    GET_ALL_COMPANIES_REQUEST, GET_ALL_COMPANIES_SUCCESS, GET_ALL_COMPANIES_FAIL,
    CREATE_COMPANY_REQUEST, CREATE_COMPANY_SUCCESS, CREATE_COMPANY_FAIL,
    UPDATE_COMPANY_REQUEST, UPDATE_COMPANY_SUCCESS, UPDATE_COMPANY_FAIL,
    DELETE_COMPANY_REQUEST, DELETE_COMPANY_SUCCESS, DELETE_COMPANY_FAIL,
    SET_COMPANY_LOADING, UPDATE_COMPANY, SET_HOLIDAYS_LOADING, GET_HOLIDAYS_SUCCESS, GET_HOLIDAYS_FAIL
} from '../actions/companyactions';

const initialState = {
    companies: [],
    holidays: [],
    currentCompany: null,
    loading: false,
    message: '',
    error: null
};

function companyReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_COMPANY:
            return {
                ...state,
                loading: true,
                company: action.company
            };

        case SET_HOLIDAYS_LOADING:
            return { ...state, loading: action.payload };

        case GET_HOLIDAYS_SUCCESS:
            return { ...state, holidays: action.payload, error: null };

        case GET_HOLIDAYS_FAIL:
            return { ...state, error: action.error };
        case SET_COMPANY_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        // --- GET BY ID ---
        case GET_COMPANY_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_COMPANY_SUCCESS:
            return {
                ...state,
                currentCompany: action.payload,
                loading: false,
                message: 'Société récupérée avec succès'
            };
        case GET_COMPANY_FAIL:
            return { ...state, loading: false, error: action.error, message: 'Échec de la récupération' };

        // --- GET BY CODE ---
        case GET_COMPANY_BY_CODE_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_COMPANY_BY_CODE_SUCCESS:
            return { ...state, currentCompany: action.payload, loading: false, message: '' };
        case GET_COMPANY_BY_CODE_FAIL:
            return { ...state, loading: false, error: action.error };

        // --- GET ALL ---
        case GET_ALL_COMPANIES_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_ALL_COMPANIES_SUCCESS:
            return { ...state, companies: action.payload, loading: false, message: '' };
        case GET_ALL_COMPANIES_FAIL:
            return { ...state, loading: false, error: action.error };

        // --- CREATE ---
        case CREATE_COMPANY_REQUEST:
            return { ...state, loading: true, error: null };
        case CREATE_COMPANY_SUCCESS:
            return {
                ...state,
                companies: [...state.companies, action.payload],
                loading: false,
                message: ''
            };
        case CREATE_COMPANY_FAIL:
            return { ...state, loading: false, error: action.error };

        // --- UPDATE ---
        case UPDATE_COMPANY_REQUEST:
            return { ...state, loading: true, error: null };
        case UPDATE_COMPANY_SUCCESS:
            return {
                ...state,
                companies: state.companies.map(c => (c.id === action.payload.id ? action.payload : c)),
                currentCompany: state.currentCompany?.id === action.payload.id ? action.payload : state.currentCompany,
                loading: false,
                message: ''
            };
        case UPDATE_COMPANY_FAIL:
            return { ...state, loading: false, error: action.error };

        // --- DELETE ---
        case DELETE_COMPANY_REQUEST:
            return { ...state, loading: true, error: null };
        case DELETE_COMPANY_SUCCESS:
            return {
                ...state,
                companies: state.companies.filter(c => c.id !== action.payload.companyId),
                currentCompany: state.currentCompany?.id === action.payload.companyId ? null : state.currentCompany,
                loading: false,
                message: ''
            };
        case DELETE_COMPANY_FAIL:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export default companyReducer;
